export default "__VITE_ASSET__fXWLx7IY__"